import {css} from "lit-element/lit-element.js";
export default css`.summary-table {
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMjExMjI4NjU4MS9zcmMvcGFja2FnZXMvd2ViY29tcG9uZW50cy9zcmMvY29tcG9uZW50cy93aXphcmQvYXRsYXMtc3VtbWFyeS10YWJsZSIsInNvdXJjZXMiOlsiYXRsYXMtc3VtbWFyeS10YWJsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0kiLCJzb3VyY2VzQ29udGVudCI6WyIuc3VtbWFyeS10YWJsZSB7XG4gICAgd2lkdGg6IDEwMCU7XG59XG4iXX0= */`;
